import { AuthService } from "../services/authentication.service";

export class UploadService {

    static readonly APIUrl = process.env.REACT_APP_API_URL as string; // API server domain

    // upload file
    public static uploadFile(formData: FormData) {
     
        const headers = {
            'Authorization': ''
        }
    
        // Setting Authorization header
        if (AuthService.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + AuthService.getToken();
        }

        return fetch(`${UploadService.APIUrl}/api/upload`, {
            method: 'POST',
            headers: headers,
            body: formData
          }).then(response => {
            return response.text().then((text: string) => {
                return text;
            });
          });
    }



}